import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tags"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

// eslint-disable-next-line import/no-extraneous-dependencies

import { getSentryClient } from './utils/sentry-client';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function decorateScope(scope, context) {
  var tags = context.tags,
    otherContext = _objectWithoutProperties(context, _excluded);
  if (tags) {
    scope.setTags(tags);
  }
  if (Object.keys(otherContext).length) {
    scope.setExtras(otherContext);
  }
  return scope;
}
export function logException(_x, _x2) {
  return _logException.apply(this, arguments);
}
function _logException() {
  _logException = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ex, name) {
    var context,
      sentryClient,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          context = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          _context.prev = 1;
          _context.next = 4;
          return getSentryClient();
        case 4:
          sentryClient = _context.sent;
          if (!(!sentryClient || typeof sentryClient.captureException !== 'function')) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return");
        case 7:
          sentryClient.withScope(function (scope) {
            var _context$packageName, _context$packageVersi;
            decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', (_context$packageName = context.packageName) !== null && _context$packageName !== void 0 ? _context$packageName : 'unknown');
            scope.setTag('packageVersion', (_context$packageVersi = context.packageVersion) !== null && _context$packageVersi !== void 0 ? _context$packageVersi : 'unknown');
            sentryClient.captureException(ex, scope);
          });
          _context.next = 12;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _logException.apply(this, arguments);
}
function logMessage(_x3, _x4) {
  return _logMessage.apply(this, arguments);
}
function _logMessage() {
  _logMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(severity, message) {
    var context,
      sentryClient,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          context = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          _context2.next = 3;
          return getSentryClient();
        case 3:
          sentryClient = _context2.sent;
          if (!(!sentryClient || typeof sentryClient.captureException !== 'function')) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          sentryClient.withScope(function (scope) {
            var _context$packageName2, _context$packageVersi2;
            decorateScope(scope, context);
            // The Severity enum is being replaced by SeverityLevel type in v7 anyway
            scope.setLevel(severity);
            scope.setTag('packageName', (_context$packageName2 = context.packageName) !== null && _context$packageName2 !== void 0 ? _context$packageName2 : 'unknown');
            scope.setTag('packageVersion', (_context$packageVersi2 = context.packageVersion) !== null && _context$packageVersi2 !== void 0 ? _context$packageVersi2 : 'unknown');
            sentryClient.captureMessage(message, scope);
          });
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _logMessage.apply(this, arguments);
}
export function logErrorMessage(message) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  logMessage('error', message, context).catch(function () {});
}
export function logInfoMessage(message) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  logMessage('info', message, context).catch(function () {});
}
export var createErrorHandler = function createErrorHandler(details) {
  return function (error, message) {
    var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    logException(error, message, {
      tags: _objectSpread(_objectSpread({}, details), tags)
    });
  };
};
export var logExceptionWithPackageContext = function logExceptionWithPackageContext(packageContext) {
  return function () {
    // Intentionally not awaiting the promise here as we don't need the result
    logException(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], _objectSpread(_objectSpread({}, arguments.length <= 2 ? undefined : arguments[2]), {}, {
      packageName: packageContext.packageName,
      packageVersion: packageContext.packageVersion
    }));
  };
};
export var logErrorMessageWithPackageContext = function logErrorMessageWithPackageContext(packageContext) {
  return function () {
    // Intentionally not awaiting the promise here as we don't need the result
    logErrorMessage(arguments.length <= 0 ? undefined : arguments[0], _objectSpread(_objectSpread({}, arguments.length <= 1 ? undefined : arguments[1]), {}, {
      packageName: packageContext.packageName,
      packageVersion: packageContext.packageVersion
    }));
  };
};
export var logInfoMessageWithPackageContext = function logInfoMessageWithPackageContext(packageContext) {
  return function () {
    // Intentionally not awaiting the promise here as we don't need the result
    logInfoMessage(arguments.length <= 0 ? undefined : arguments[0], _objectSpread(_objectSpread({}, arguments.length <= 1 ? undefined : arguments[1]), {}, {
      packageName: packageContext.packageName,
      packageVersion: packageContext.packageVersion
    }));
  };
};
export var createErrorHandlerWithPackageContext = function createErrorHandlerWithPackageContext(packageContext) {
  return function () {
    return createErrorHandler(_objectSpread(_objectSpread({}, arguments.length <= 0 ? undefined : arguments[0]), {}, {
      packageName: packageContext.packageName,
      packageVersion: packageContext.packageVersion
    }));
  };
};
export function addBreadcrumb(_x5) {
  return _addBreadcrumb.apply(this, arguments);
}
function _addBreadcrumb() {
  _addBreadcrumb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(crumb) {
    var sentryClient;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getSentryClient();
        case 2:
          sentryClient = _context3.sent;
          sentryClient.withScope(function (scope) {
            scope.addBreadcrumb(typeof crumb === 'string' ? {
              message: crumb
            } : crumb);
          });
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _addBreadcrumb.apply(this, arguments);
}